import { c as _c } from "react/compiler-runtime";
import { TextCenter } from '@/components/Atoms/TextCenter/TextCenter';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import type { IBreadcrumbItem } from '@/components/Molecules/Breadcrumb/Breadcrumb';
import { ScheduledEventsList } from '@/components/Organisms/SheduledEventList/ScheduledEventList';
import { EventsListTemplate } from '@/components/Templates/Events/EventsListTemplate';
import useTranslation from '@/hooks/useTranslation';
import type { IEvent } from '@/interfaces';
import type { Translate } from 'next-translate';
export const eventsBreadcrumbs = (t: Translate): IBreadcrumbItem[] => [{
  url: '/events',
  label: t('common:SiteSection.events')
}];
interface IEventsPageProps {
  data: {
    total: number;
    items?: IEvent[];
  };
}
export const EventsPage = t0 => {
  const $ = _c(12);
  const {
    data
  } = t0;
  const {
    t
  } = useTranslation("events");
  let t1;
  if ($[0] !== t) {
    t1 = t("ListTemplate.upcoming_heading");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.items) {
    t2 = <ScheduledEventsList items={data.items} />;
    $[2] = data.items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("Upcoming.footer_notice");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <CenteredPageContent><TextCenter>{t3}</TextCenter></CenteredPageContent>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <EventsListTemplate active="events" title={t1}>{t2}{t4}</EventsListTemplate>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};